import React, { useEffect } from "react";
import Table from "react-bootstrap/Table";
import Container from "react-bootstrap/Container";
import Button from "react-bootstrap/Button";
import Category from "../component/Category";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchCategories } from "../store/actions/creator";

export default function CategoriesPage() {
  // const [categories] = useFetch('categories')
  const dispatch = useDispatch();
  const { searchQuery } = useSelector((state) => state.custom);
  useEffect(() => dispatch(fetchCategories()), [dispatch]);
  // useEffect(() => dispatch({type : CATEGORIES_SET_TO_DEFAULT}),[dispatch])
  //
  const { categories } = useSelector((state) => state.category);

  return (
    <Container>
      <br />
      <h1>Table of Categories</h1>
      <div className="myButton" >
        <Button as={Link} to={"/categories/add"}>
          +
        </Button>
      </div>
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>No</th>
            <th>Name</th>
            <th>Created At</th>
            <th>Updated At</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {categories
            .filter((el) =>
              el.name.toLowerCase().includes(searchQuery.toLowerCase())
            )
            .map((category, index) => {
              return (
                <Category category={category} index={index} key={category.id} />
              );
            })}
        </tbody>
      </Table>
    </Container>
  );
}
